export default __webpack_public_path__ + "static/media/windows-icon-color.287a237d.jpeg";